import React from 'react'
import { useStyles } from './FlyOutStorefrontTemplateWrapper.styles'
import { TemplateCreationFormikWrapper } from '../TemplateCreationFormikWrapper/TemplateCreationFormikWrapper'
export const FlyOutStorefrontTemplateWrapper: React.FC = () => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.container}
      data-testid="storefront-template-wrapper"
    >
      <TemplateCreationFormikWrapper />
    </div>
  )
}
